import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
//import { ContactsService } from '../../services/contacts.service';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { ContactVm } from 'src/app/viewModels/core/contacts-vm';


import {FormControl} from '@angular/forms';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { ContactsService } from '../../services/coreService/contacts.service';

export interface State {
  name: string;
  email: string;
  role: string;
  pic: string,
}


@Component({
  selector: 'app-contact-list',
  templateUrl: './contact-list.component.html',
  styleUrls: ['./contact-list.component.scss']
})
export class ContactListComponent implements OnInit {

  showdetail:boolean = true;
  addnewContact:boolean = false;
  showAddContact:boolean = false;
  addnewSharedContact:boolean = false;
  
  value = '';
  addNew(){
    this.showAddContact = !this.showAddContact;
  }
  getClose(message){
    this.showAddContact = message;
  }

  addContact(){
    this.addnewContact = !this.addnewContact;
  }

  addSharedContact(){
    this.addnewSharedContact = !this.addnewSharedContact;
  }
  

  @Output() showContactDetail = new EventEmitter<boolean>();
  currentUser: any;
  databaseId: string;
  organizationId: string;
  responseHolder: any;
  contactsList: any;
  constructor(private statusConst: StatusConstant, private loaderService: LoaderService,
    private contactsService: ContactsService, private toastr: ToastrService, private contactVm: ContactVm,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses) {

    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId');
    this.organizationId = sessionStorage.getItem('organizationID');
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);


    this.filteredStates = this.stateCtrl.valueChanges
    .pipe(
      startWith(''),
      map(state => state ? this._filterStates(state) : this.states.slice())
    );

  }

  private _filterStates(value: string): State[] {
    const filterValue = value.toLowerCase();

    return this.states.filter(state => state.name.toLowerCase().indexOf(filterValue) === 0);
  }



  ngOnInit(): void {
    //this.getContacts();
  }

  contactDetail(message:boolean){
      this.showContactDetail.emit(message);
  }
  // getContacts() {
     
  //   this.contactVm.DatabaseID = Number(this.databaseId);
  //   this.contactVm.OrganizationID = Number(this.organizationId);
  //   this.contactVm.UserID = this.currentUser.UID;
  //   this.loaderService.show();
  //   this.contactsService.getContacts(this.contactVm).subscribe(response => {
  //     if (response != undefined) {
  //       this.responseHolder = response;
  //       if (this.responseHolder.status == this.statusConst.statusSuccess) {
  //         this.contactsList = response.data;
  //         this.loaderService.hide();
  //       }
  //     }
  //   });
  // }

  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;

  states: State[] = [
    {
      name: 'Abbott',
      email: 'Abbott@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/Abbott.jpg'
    },
    {
      name: 'Alice',
      email: 'alice.@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/alice.jpg'
    },
    {
      name: 'Carl',
      email: 'carl@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/carl.jpg'
    },
    {
      name: 'Jane',
      email: 'jane@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/jane.jpg'
    },
    {
      name: 'Tillman',
      email: 'tillman.@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/Tillman.jpg'
    },
    {
      name: 'Josefina',
      email: 'Josefina@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/Josefina.jpg'
    },
    {
      name: 'Create New',
      email: ' ',
      role: ' ',
      pic: ' '
    },

  ];




}
